import { ImpulseFormUnit } from "~/tools/impulse-form";
import { isArrayEqual } from "~/tools/is-array-equal";

import type { DashboardSpec } from "../../../../common/dashboard-spec";

export function initVariablesFormState(spec: DashboardSpec) {
	return ImpulseFormUnit(spec.variables, {
		isInputEqual: (left, right) => isArrayEqual(left, right, (varLeft, varRight) => varLeft.isEqual(varRight)),
	});
}

export type FormState = ReturnType<typeof initVariablesFormState>;
